export default __webpack_public_path__ + "static/thumbnail4-1d7510f6c9d60bc2b6bb135111365d7a.jpg";